/**
 * The loading state: eight nodes pulsing on a ring. ANANSI has no spinners and
 * no skeletons, so this is what waiting looks like everywhere.
 *
 * `inline` drops the label and renders only the ring, sized to sit inside a
 * button — the confirm dialog's "Working" state uses it at 16px (spec §5.1).
 */
export function Pulse({
  label = "LOADING",
  size = 80,
  inline = false,
}: {
  label?: string;
  size?: number;
  inline?: boolean;
}) {
  const c = size / 2;
  const r = size * 0.375;
  const dot = Math.max(1, size / 40);
  const ring = (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden>
      {Array.from({ length: 8 }).map((_, i) => {
        const a = (i * Math.PI) / 4;
        const x = c + Math.cos(a) * r;
        const y = c + Math.sin(a) * r;
        return (
          <circle
            key={i}
            cx={x}
            cy={y}
            r={dot}
            fill="currentColor"
            style={{ animation: `pulseNode 1.2s ease-in-out infinite`, animationDelay: `${i * 0.08}s` }}
          />
        );
      })}
    </svg>
  );
  if (inline) return <span className="pulse--inline">{ring}</span>;
  return (
    <div className="pulse">
      {ring}
      <div className="pulse__label uppercase-label">{label}</div>
    </div>
  );
}
